import destinations from './destinations';
import hamburger from './hamburger';
import secondary from './secondary';

export default function nav() {
  destinations();
  hamburger();
  secondary();
}
